module.exports = __webpack_public_path__ + "img/poster-2.1dffc7a2.png";